// Libs
import classNames from 'classnames/bind';
import { Tab, TabProps, Box } from '@mui/material';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './BaseTab.module.scss';

type BaseTabProps = TabProps;

const cx = classNames.bind(styles);

const BaseTab = (props: BaseTabProps) => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box className={cx('tab-item-container')}>
      <Tab {...props}>{props.children}</Tab>
    </Box>
  );
};

export default BaseTab;
